// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__8blvG","loader":"Loader_loader__lggK7","spin":"Loader_spin__B1lV2"};